module.exports = __webpack_public_path__ + "static/media/vegitables_65.488de48c.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_65.csv
// module id = 652
// module chunks = 0